function mgSlideUpDown() {

    try {
        /* forDropDown for any */
        const forDropDowns = function() {
            $('.parent-menu').on('click', function(e) {
                $(this).next('.child-menu').slideToggle(300);
            });
        };
        forDropDowns();

        /* for One forDropDown */
        const forDropDown = function() {
            $('.parent-down').on('click', function(e) {
                // console.log('this', $(this).siblings());
                $(this).next('.child-down').slideToggle(300);
            });
        };
        forDropDown();
    } catch (err) {
        console.log(' ERROR slideUpDown');
    }
}